var render = function () {
var _obj;
var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{class:( _obj = {
  'client-name': true
}, _obj[("client-name-" + _vm.systemColor)] = true, _obj )},[_c('h4',[_vm._v(_vm._s(_vm.clientName))])])}
var staticRenderFns = []

export { render, staticRenderFns }